import axiosInstance from "./axiosInstance";

export const fetchSubscriptionBilling = (billingCycle = "MONTHLY") =>
  axiosInstance.get("/admin/subscription-billing", { params: { billing_cycle: billingCycle } });
export const setupSubscriptionBilling = (billingCycle, paymentMethod, acceptAutoPay) =>
  axiosInstance.post("/admin/subscription-billing/setup", { billing_cycle: billingCycle, payment_method: paymentMethod, accept_auto_pay: acceptAutoPay });
export const createManualSubscriptionPayment = (billingCycle, paymentMethod) =>
  axiosInstance.post("/admin/subscription-billing/manual-checkout", { billing_cycle: billingCycle, payment_method: paymentMethod });
export const createAddonPaymentCheckout = (requestId, paymentMethod) =>
  axiosInstance.post(`/admin/subscription-billing/add-ons/${requestId}/checkout`, { payment_method: paymentMethod });
export const recordBillingPaymentReturn = (paymentType = "manual", providerStatus = "") =>
  axiosInstance.post("/admin/subscription-billing/return", { payment_type: paymentType, status: providerStatus });
export const fetchBillingHistory = (page = 1, pageSize = 10, status = "") => {
  const params = { page, page_size: pageSize };
  if (status) params.status = status;
  return axiosInstance.get("/admin/subscription-billing/history", { params });
};
export const cancelSubscriptionBilling = () => axiosInstance.delete("/admin/subscription-billing");
